import React from "react";
import { Checkbox, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import FilterDropdown from "modules/common/components/filters/filterDropdown";

interface ICheckboxDropdown<T extends string> {
    label: string;
    options: T[];
    currentOptions: T[] | undefined;
    onClickOption: (option: T[]) => void;
}

const CheckboxDropdown = <T extends string>(props: ICheckboxDropdown<T>) => {
    const getUpdatedValues = (value: T) : T[] | undefined => {
        return props.currentOptions?.includes(value)
            ? props.currentOptions?.filter(current => current !== value)
            : props.currentOptions?.concat([value]);
    };

    const onClick = (option: T) => {
        const updatedValues = getUpdatedValues(option);
        props.onClickOption(updatedValues ?? []);
    };

    return (
        <FilterDropdown text={props.label}>
            <List disablePadding>
                {props.options.map((option) => (
                    <ListItemButton key={option}
                        dense
                        onClick={() => onClick(option)}>
                        <ListItemIcon className="callout-checkbox">
                            <Checkbox
                                edge="start"
                                tabIndex={-1}
                                disableRipple
                                size="small"
                                color="primary"
                                checked={props.currentOptions?.includes(option)}
                            />
                        </ListItemIcon>
                        <ListItemText primary={option} />
                    </ListItemButton>
                ))}
            </List>
        </FilterDropdown>
    );
};

export default CheckboxDropdown;
